import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface LocationPermissionDialogData {
    message: string;
    retryCount?: number;
    maxRetries?: number;
}

@Component({
    selector: 'app-location-permission-dialog',
    templateUrl: './location-permission-dialog.component.html',
    styleUrls: ['./location-permission-dialog.component.scss']
})
export class LocationPermissionDialogComponent {
    isLocalhost = false;
    canRetry = true;
    retryText = '';

    constructor(
        public dialogRef: MatDialogRef<LocationPermissionDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: LocationPermissionDialogData
    ) {
        // Check if we're on localhost
        this.isLocalhost = window.location.hostname === 'localhost' ||
            window.location.hostname === '127.0.0.1' ||
            window.location.protocol === 'http:';

        // Check if we can still retry
        if (this.data.retryCount && this.data.maxRetries) {
            this.canRetry = this.data.retryCount < this.data.maxRetries;
            this.retryText = `Retry (${this.data.retryCount}/${this.data.maxRetries})`;
        } else {
            this.retryText = 'Enable Location Access';
        }
    }

    onRetry(): void {
        this.dialogRef.close('retry');
    }

    onUseFallback(): void {
        this.dialogRef.close('fallback');
    }

    onClose(): void {
        this.dialogRef.close();
    }
}
